import React from 'react';
import PropTypes from 'prop-types';
import CartItem from './CartItem';
import {useNavigate} from 'react-router-dom';
import {groupBy} from 'lodash';
import {Typography} from '@customink/pigment-react';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const DesignGroupItems = props => {
  const {designName, groupedItems, index} = props;
  const navigate = useNavigate();

  const editQuantities = () => {
    navigate('/next/quote');
  };

  return (
    <div key={index} className="cartSummary-Items-groupedItems">
      <Typography variant="heading4">{designName}</Typography>
      <div className="cartSummary-Items-groupedItems-items">
        {groupedItems.map(cartItem => (
          <CartItem
            key={cartItem.id}
            {...cartItem}
            allowEditSizeQuantities={false}
            borderAroundStyles={props.borderAroundStyles}
            onChangeQuantities={editQuantities}
            showSizeQuantities={props.showSizeQuantities}
            showDividerBetweenStyles={props.showDividerBetweenStyles}
            shouldRenderNewLinePrice={props.shouldRenderNewLinePrice}
          />
        ))}
      </div>
    </div>
  );
};

DesignGroupItems.displayName = 'DesignGroupItems';
const propTypes = {
  allowEditQuantities: PropTypes.bool,
  alreadyAddedItems: PropTypes.array,
  borderAroundStyles: PropTypes.bool,
  designName: PropTypes.string,
  groupedItems: PropTypes.array,
  index: PropTypes.number,
  recentlyAddedItems: PropTypes.array,
  shouldRenderNewLinePrice: PropTypes.bool,
  showDividerBetweenStyles: PropTypes.bool,
  showSizeQuantities: PropTypes.bool
};

DesignGroupItems.propTypes = propTypes;

/** @param {PropTypes.InferProps<typeof multiItemCartPropTypes>} props - Component properties. */
export const MultiItemCart = props => {
  const {alreadyAddedItems, recentlyAddedItems} = props;
  const renderAlreadyAddedItems = () => {
    const groupedAlreadyAddedItems = groupBy(alreadyAddedItems, 'designName');

    return (
      <div className="cartSummary-Items-recentlyAdded">
        <div className="cartSummary-Items-recentlyAdded-items">
          {Object.keys(groupedAlreadyAddedItems).map((key, i) => (
            <DesignGroupItems
              {...props}
              designName={key}
              groupedItems={groupedAlreadyAddedItems[key]}
              index={i}
              key={i}
            />
          ))}
        </div>
      </div>
    );
  };

  const renderRecentlyAddedItems = () => {
    const groupedRecentlyAddedItems = groupBy(recentlyAddedItems, 'designName');

    return (
      <div className="cartSummary-Items-recentlyAdded">
        {Object.keys(groupedRecentlyAddedItems).map((key, i) => (
          <DesignGroupItems
            {...props}
            designName={key}
            groupedItems={groupedRecentlyAddedItems[key]}
            index={i}
            key={i}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="cartSummary-Items--multiItem">
      {renderRecentlyAddedItems()}
      {alreadyAddedItems.length > 0 ? renderAlreadyAddedItems() : ''}
    </div>
  );
};

const multiItemCartPropTypes = {
  allowEditQuantities: PropTypes.bool,
  alreadyAddedItems: PropTypes.array,
  borderAroundStyles: PropTypes.bool,
  recentlyAddedItems: PropTypes.array,
  shouldRenderNewLinePrice: PropTypes.bool,
  showDividerBetweenStyles: PropTypes.bool,
  showSizeQuantities: PropTypes.bool
};

MultiItemCart.propTypes = multiItemCartPropTypes;

MultiItemCart.defaultProps = {
  alreadyAddedItems: []
};

export default MultiItemCart;
